import { FaArrowDown, FaArrowUp } from "react-icons/fa";

import {
	Flex,
	Text,
	Show,
	Image,
	Stack,
	Button,
	Divider,
	Collapse,
	useBoolean,
} from "@chakra-ui/react";

import { Interests } from "../components/Interests";

import reflection from "../media/reflection.jpg";
import breakfast from "../media/breakfast.jpg";
import lick from "../media/lick.jpg";
import view from "../media/view.jpg";
import sip from "../media/sip.jpg";

export const Experience = () => {
	const [showMore, setShowMore] = useBoolean();

	return (
		<Stack id="experience" gap="6" pt={{ base: "4", md: "8" }}>
			<Flex gap="8" align="center">
				<Show above="md">
					<Image
						h="480px"
						src={sip}
						rounded="3"
						alt="experience"
						objectFit="cover"
						w={{ md: "50%", lg: "45%", xl: "40%" }}
						onContextMenu={(e) => e.preventDefault()}
					/>
				</Show>

				<Stack
					gap="4"
					h={{ md: "480px" }}
					justify="space-between"
					px={{ base: "4", md: "0" }}
				>
					<Stack
						overflowY={{ md: "auto" }}
						css={{
							"&::-webkit-scrollbar": {
								width: 0,
								background: "transparent",
							},
						}}
					>
						<Text fontSize="xl">
							<i>An encounter with Lulu feels like your dream fling.</i>
						</Text>

						<Show above="md">
							<Divider
								mt="1"
								mb="1.5"
								borderRadius="3"
								borderTopWidth="1.5px"
								borderBottomWidth="1.5px"
								borderColor="brand.mid"
							/>
						</Show>

						<Text>
							Picture yourself on that dream vacation, enjoying a wonderful day
							out when someone catches your eye.
						</Text>
						<Text>
							Gorgeous honey brown eyes glinting in the sunlight. Slowly you
							work your gaze down her womanly curves, savouring every moment and
							before you know it you’re enraptured.
						</Text>
						<Text>
							She begins walking up to you, every step adding to the
							anticipation and delight.
						</Text>
						<Text>
							There is an instant connection and you get lost in a whirlwind of
							an evening, a delectable wine paired with the most decadent
							dessert.
						</Text>
						<Text>
							In the morning you soak in the events of the evening with a
							gorgeous woman by your side and an aromatic coffee on your lips.
						</Text>
					</Stack>

					<Show above="md">
						<Button
							pr="3.5"
							size="sm"
							rounded="3"
							fontSize="md"
							w="fit-content"
							bg="brand.dark"
							color="brand.light"
							fontFamily="Kalnia Variable"
							_hover={{ bg: "brand.contrast" }}
							rightIcon={showMore ? <FaArrowUp /> : <FaArrowDown />}
							onClick={setShowMore.toggle}
						>
							{showMore ? "HIDE" : "LEARN"} MORE ABOUT ME
						</Button>
					</Show>
				</Stack>
			</Flex>

			<Collapse in={showMore} animateOpacity>
				<Interests />
			</Collapse>

			<Show below="md">
				<Image
					src={view}
					alt="experience"
					objectFit="cover"
					onContextMenu={(e) => e.preventDefault()}
				/>

				<Interests />

				<Image
					src={reflection}
					alt="experience"
					objectFit="cover"
					onContextMenu={(e) => e.preventDefault()}
				/>
			</Show>

			<Show above="md">
				<Flex gap="8" py="2">
					<Stack gap="3" justify="space-between" w="100%">
						<Image
							src={lick}
							rounded="3"
							alt="experience"
							objectFit="cover"
							onContextMenu={(e) => e.preventDefault()}
							h={{ md: "300px", lg: "380px", xl: "420px" }}
						/>

						<Text px="0">
							You deserve a break. <i>Treat yourself.</i>
						</Text>
					</Stack>

					<Image
						w="70%"
						rounded="3"
						alt="experience"
						objectFit="cover"
						onContextMenu={(e) => e.preventDefault()}
						h={{ md: "355px", lg: "435px", xl: "475px" }}
						src={breakfast}
					/>
				</Flex>

				<Image
					w="100%"
					h="300px"
					src={reflection}
					alt="experience"
					objectFit="cover"
					onContextMenu={(e) => e.preventDefault()}
					rounded="3"
				/>
			</Show>
		</Stack>
	);
};
